import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Popover } from "@mui/material";
import "../../SysGuard.scss";
import columnsConfig from "../ContentPages/SysGuardColumnConfig";
import { isNull } from "lodash";
import { useSelector } from "react-redux";
import SysGuardFilter from "./SysGuardFilter";
import LocationAccordionTable from "./LocationAccordionTable";

function DataTable({
  data,
  type,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  totalElements,
  setPopupDetails,
  setPopupOpen,
  dataSourceType,
  dataSourceId,
  loc,
}) {
  const alertUpdated = useSelector(
    (state) => state.alertStatusChanged.alertUpdated,
  );
  const appNamesFilter =
    useSelector(
      (state) => state.SysGuardReducer.sysGuardSelectedApplications,
    ) || [];
  const countryNameFilter =
    useSelector(
      (state) => state.SysGuardReducer.sysGuardSelectedCountryNames,
    ) || [];
  const threatFilter =
    useSelector(
      (state) => state.SysGuardReducer.sysGuardSelectedThreatProbabilities,
    ) || [];
  const userNameFilter = useSelector(
    (state) => state.SysGuardReducer.sysGuardSelectedUserName,
  );
  const MFAFilter = useSelector(
    (state) => state.SysGuardReducer.sysGuardSelectedMFAList,
  );
  const UserRiskFilter = useSelector(
    (state) => state.SysGuardReducer.sysGuardSelectedRiskFactorList,
  );
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);
  const sysGuardDataSource = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource,
  );

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [filterColumnField, setFilterColumnField] = useState(null);
  const [activeFilterField, setActiveFilterField] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverData, setPopoverData] = useState([]); // stores remainingCountryData

  const handlePopoverToggle = (event, data) => {
    setAnchorEl(event.currentTarget);
    setPopoverData(data);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverData([]);
  };

  const handleFilterIconClick = (event, columnField) => {
    event.stopPropagation();
    setFilterAnchorEl(event.currentTarget);
    setFilterColumnField(columnField);
    setActiveFilterField(columnField);
  };

  const handleCloseFilter = () => {
    setFilterAnchorEl(null);
    setFilterColumnField(null);
    setActiveFilterField(null);
  };

  const handleCellClick = (rowData, loc) => {
    setPopupDetails({
      popupData: rowData,
      popupKey: rowData.id,
      popupLocation: loc,
    });
    setPopupOpen(true);
  };

  const tableColumns = columnsConfig(
    handleCellClick,
    dataSourceType,
    appNamesFilter,
    countryNameFilter,
    threatFilter,
    userNameFilter,
    MFAFilter,
    UserRiskFilter,
    handleFilterIconClick,
    activeFilterField,
    isIncognito,
    anchorEl,
    handlePopoverToggle,
    handlePopoverClose,
    popoverData,
    sysGuardDataSource,
  );

  const columns = tableColumns[type] || [];

  useEffect(() => {
    if (!alertUpdated || !data?.length) return;
    setPopupDetails((prev) => {
      if (typeof prev?.popupKey !== "number") return prev;
      const updatedRow = data.find((row) => row.id === prev.popupKey);
      if (!updatedRow) return prev;
      return {
        ...prev,
        popupData: updatedRow,
      };
    });
  }, [alertUpdated, data, setPopupDetails]);

  const rows = !isNull(data)
    ? data.map((row, index) => ({
        ...row,
        id: row.id ?? index,
      }))
    : [];

  return (
    <div className="tableContainer">
      {type === "Locations" ? (
        <LocationAccordionTable
          rows={rows}
          columns={tableColumns["Locations"]}
          cityColumns={tableColumns["Cities"]}
          dataSourceId={dataSourceId}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
        />
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={totalElements}
          autoHeight
          disableSelectionOnClick
          className="dataGrid"
          pagination
          paginationMode="server"
          paginationModel={{ page: currentPage, pageSize }}
          onPaginationModelChange={(newModel) => {
            setCurrentPage(newModel.page);
            setPageSize(newModel.pageSize);
          }}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          disableColumnMenu
          disableRowSelectionOnClick
          getRowClassName={(params) =>
            loc === "Users" && params.row.status === "DELETED"
              ? "deleted-user-row"
              : ""
          }
          localeText={{
            noRowsLabel: "No Data Available",
          }}
        />
      )}

      <Popover
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <SysGuardFilter
          loc={loc}
          dataSourceId={dataSourceId}
          pageSize={pageSize}
          currentPage={currentPage}
          popupClose={handleCloseFilter}
          filterField={filterColumnField}
        />
      </Popover>
    </div>
  );
}
export default DataTable;
